<template>
    <div class="sustainable-component equality-report-gender-distribution">
        <!--<div class="bg-success mb-3 p-3 rounded">vue equality-report-gender-distribution</div>-->
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12 col-md-6">
                    <a href="javascript:void(0)" @click="PrintGenderDistributionByJobposition">Visa kvinnors fördelning i alla befattningar</a>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 col-md-6">
                    <div v-if="analysisCriterias1.length > 1">
                        <v-select bg-color="white" variant="outlined" v-bind:label="analysisCriteria1Name" :items="analysisCriterias1" item-title="Name" item-value="Val" v-model="analysisCriteria1"></v-select>
                    </div>

                    <div v-if="analysisCriterias2.length > 1">
                        <v-select bg-color="white" variant="outlined" v-bind:label="analysisCriteria2Name" :items="analysisCriterias2" item-title="Name" item-value="Val" v-model="analysisCriteria2"></v-select>
                    </div>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import AdminService from "../../Services/AdminService";
    import CommonSpinner from '../../common/common-spinner.vue'

    export default {

        name: 'equality-report-gender-distribution',
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
        },
        methods: {
            async PrintGenderDistributionByJobposition() {
                this.newWindow = window.open('/equalityPrint/PrintGenderDistributionByCompany?' + this.getAnalysisParameters(), '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            getAnalysisParameters(){
                var ret = "";
                if(this.analysisCriteria1 != null)
                    ret = "&analysisCriteria1=" + this.analysisCriteria1;
                if(this.analysisCriteria2 != null)
                    ret += "&analysisCriteria2=" + this.analysisCriteria2;
                return ret;
            },
            async getEmployeeAnalysisCriteria() {
                this.loading++;
                try {
                    var analysisCriterias = await AdminService.getAnalysisCriterias();
                    if (analysisCriterias.Criteria1.Active == true) {
                        //this.analysisCriteria1 = analysisCriterias.Criteria1.Name;
                        this.analysisCriterias1 = analysisCriterias.Criteria1.ContentItems;
                        this.analysisCriteria1Name = analysisCriterias.Criteria1.Name;
                    }

                    if (analysisCriterias.Criteria2.Active == true) {
                        //this.analysisCriteria2 = analysisCriterias.Criteria2.Name;
                        this.analysisCriterias2 = analysisCriterias.Criteria2.ContentItems;
                        this.analysisCriteria2Name = analysisCriterias.Criteria2.Name;
                    }
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                internalModel:{
                    JobPositions: [],
                    JobTaskSuggestions: [],
                },
                jobPositionTasks: [],
                jobPositionBlocks: [],
                jobPositionName: '',
                jobBlockName: '',
                jobBlockNumber: -1,
                enableRegulation: false,
                newWindow: {},
                analysisCriteria1: null,
                analysisCriterias1: [],
                analysisCriteria1Name: null,
                analysisCriteria2: null,
                analysisCriteria2Name: null,
                analysisCriterias2: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {

        },
        mounted() {
            this.internalModel = this.model;
            this.getEmployeeAnalysisCriteria();
        },
        setup() {
            return { }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
